import styled from "styled-components";

const TextHeader = styled.div`
  color: ${props => props.theme.darkgrey};
  font-size: 22px;
  font-weight: 900;
`;

export default TextHeader;
